/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileCertificate} from '@fortawesome/pro-duotone-svg-icons';

const PdTranscriptIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faFileCertificate} {...props} />
);

export default PdTranscriptIcon;
